import { useCallback, useEffect, useSyncExternalStore } from "react";
import { useTranslation } from "react-i18next";
import { unloadApplication } from "single-spa";
import { useShellHost } from "@/shell-handle/ShellHostProvider";
import {
  getLocalServersSnapshot,
  refreshLocalServers,
  setSelectedMachineId,
  subscribeLocalServers,
} from "@/shared/localServers";

const AKVA_SCANNER_APP = "@observe/akva-network-scanner";

// Subscribes to the local-server store the React-blessed way and owns the
// side effects (initial fetch + failure toast + MFE remount) so the picker is
// just a dropdown.
export function useLocalServers() {
  const host = useShellHost();
  const { t } = useTranslation();
  const { servers, selectedMachineId } = useSyncExternalStore(
    subscribeLocalServers,
    getLocalServersSnapshot,
  );

  useEffect(() => {
    void refreshLocalServers().then((res) => {
      if (!res.ok) {
        host.handle.notify(t("Could not load local servers"), "error");
      }
    });
  }, [host, t]);

  const select = useCallback((id: number | null) => {
    setSelectedMachineId(id);
    // Remount the MFE so customProps re-resolve with the new IP. The store
    // already updated the backend URL the MFE reads as a cross-bundle fallback.
    void unloadApplication(AKVA_SCANNER_APP).catch(() => {
      /* app not loaded yet — first mount will read the selection */
    });
  }, []);

  return { servers, selectedMachineId, select };
}
